import React from 'react';
import { Alert, App, Button, Result, Space, Table } from 'antd';
import { ClearOutlined, ReloadOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { ApiError } from '../../api/types';
import { RoomsConfig } from './types';
import { useInvalidateRoomsConfigCache, useRoomsConfigs } from './queries';

const errorText = (error: unknown) => error instanceof ApiError
  ? `${error.code ? `[${error.code}] ` : ''}${error.message}`
  : error instanceof Error ? error.message : 'Request failed. Please try again.';
export const RoomsConfigsPage: React.FC = () => {
  const configs = useRoomsConfigs();
  const invalidate = useInvalidateRoomsConfigCache();
  const { message } = App.useApp();
  if (configs.error) return <Result status="error" title="Failed to load room configurations" subTitle={errorText(configs.error)} extra={<Button onClick={() => configs.refetch()}>Retry</Button>} />;
  const number = (value: number) => value.toLocaleString();
  const columns: ColumnsType<RoomsConfig> = [
    { title: 'ID', dataIndex: 'id', width: 75 },
    { title: 'Name', dataIndex: 'name' },
    { title: 'Bet', dataIndex: 'bet', render: number },
    { title: 'Minimum gold', dataIndex: 'min_gold', render: number },
    { title: 'Maximum gold', dataIndex: 'max_gold', render: number },
    { title: 'Fake minimum CCU', dataIndex: 'fake_min_ccu', render: number },
    { title: 'Fake maximum CCU', dataIndex: 'fake_max_ccu', render: number },
  ];
  return <>
    {invalidate.error && <Alert type="error" showIcon className="mb-4" message={errorText(invalidate.error)} />}
    <Space className="mb-4" wrap>
      <Button icon={<ReloadOutlined />} loading={configs.isFetching} disabled={invalidate.isPending} onClick={() => configs.refetch()}>Refresh</Button>
      <Button icon={<ClearOutlined />} loading={invalidate.isPending} onClick={() => invalidate.mutate(undefined, { onSuccess: () => { message.success('Rooms configuration cache invalidated'); } })}>Invalidate cache</Button>
    </Space>
    <Table rowKey="id" columns={columns} dataSource={configs.data || []} loading={configs.isLoading} pagination={false} scroll={{ x: 1100 }} />
  </>;
};
